import { render, staticRenderFns } from "./listDialog.vue?vue&type=template&id=061d6df1&"
import script from "./listDialog.vue?vue&type=script&lang=ts&"
export * from "./listDialog.vue?vue&type=script&lang=ts&"
import style0 from "./listDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports